// @flow
import React from "react";
import { connect } from "react-redux";

import { openTable, sortByOrder } from "../../../../data/modules/ui";
import "./LineItemTablesContainer.less";
import getProperty from "lodash.get";
import Tabs from "react-simpletabs";
import Scroll from "react-scroll";
import s from "./LineItemTablesContainer.less";

import LineItemTable from "./LineItemTable/LineItemTable";
import SectionHeader from "../../../SummarySubSections/SummarySubSection/SectionHeader/SectionHeader";

//lineItemMapping
import {
  mapMaterialLineItemData,
  mapLaborLineItemData
  // mapOverheadLineItemData,
} from "../../../../dataMappingUIHelpers/cbdLineItemMapping";
import { Checkbox } from "@nike/ruxac";

type Props = {
  ui: Object,
  expandRow: Function,
  title: string,
  totalFob: number,
  tableOpen: string,
  cbdHeaderData: Object,
  tableData: Object,
  openTable: Function,
  summaryData: Object,
  sortByOrder: Function,
  sortBy: string
};

const LineItemTablesContainer = (props: Props) => {
  const lineItemTableLookup = ["Material", "Labor", "Overhead", "Profit", "Tooling"];
  let isNby = props.cbdHeaderData.costsheetBOMType === "Footwear Logic BOM";

  return (
    <div className={`row ${s.lineItemsContainer}`}>
      {props.summaryData && (
        <div className={`col-xs-12 ${s.fullWidthColumn}`}>
          <div className={`shadowBox`}>
            <Scroll.Element name={"lineItems"} id={"lineItems"} style={{ width: "100%" }}>
              <SectionHeader title={"details"} />
            </Scroll.Element>
            <Tabs
              tabActive={lineItemTableLookup.indexOf(props.tableOpen) + 1}
              onBeforeChange={selectedIndex => {
                props.openTable(lineItemTableLookup[selectedIndex - 1]);
              }}
            >
              {props.summaryData["Material Cost"] && (
                <Tabs.Panel title="Material">
                  <div className={`${s.toogleButton}`}>
                    <Checkbox
                      label="Sort By PCX BOM"
                      onChange={value => {
                        value
                          ? props.sortByOrder("sortingNumberInt")
                          : props.sortByOrder("pccSortOrder");
                      }}
                    />
                  </div>
                  <LineItemTable
                    totalCost={props.summaryData["Material Cost"].sectionSummary.cost}
                    sortBy={props.sortBy}
                    totalFob={props.totalFob}
                    isNby={isNby}
                    tableTitle={"Material"}
                    data={mapMaterialLineItemData(
                      props.tableData.costsheetMaterialCostLineItem,
                      props.sortBy,
                      isNby
                    )}
                  />
                </Tabs.Panel>
              )}
              {props.summaryData["Labor Cost"] && (
                <Tabs.Panel title="Labor">
                  <LineItemTable
                    totalCost={props.summaryData["Labor Cost"].sectionSummary.cost}
                    totalFob={props.totalFob}
                    tableTitle={"Labor"}
                    data={mapLaborLineItemData(props.tableData.costsheetBillOfLaborLineItemDetails)}
                  />
                </Tabs.Panel>
              )}
              {/* {props.tableData.costsheetAllocatableOverheadLineItemDetails &&
                <Tabs.Panel title="Overhead">
                  <LineItemTable
                    totalFob={props.totalFob}
                    tableTitle={'Overhead'}
                    data={mapOverheadLineItemData (
                      props.tableData
                        .costsheetAllocatableOverheadLineItemDetails
                    )}
                  />
                </Tabs.Panel>} */}
            </Tabs>
          </div>
        </div>
      )}
    </div>
  );
};

const mapStateToProps = state => ({
  tableOpen: state.ui.tableOpen,
  sortBy: state.ui.sortBy,
  totalFob: getProperty(state.ui, ["cbdUIMapping", "cbdHeader", "costsheetFobCostUsd"], {}),
  cbdHeaderData: getProperty(state.ui, ["data", "cbdHeader"], {}),
  tableData: getProperty(state.ui, ["data", "cbdLineItems"], {})
});
const mapDispatchToProps = { openTable, sortByOrder };

export default connect(mapStateToProps, mapDispatchToProps)(LineItemTablesContainer);



// WEBPACK FOOTER //
// ./src/components/CBDTables/LineItemTables/LineItemTablesContainer/LineItemTablesContainer.js